import { render, staticRenderFns } from "./BottomPopup.vue?vue&type=template&id=12c2e9c5&scoped=true&"
import script from "./BottomPopup.vue?vue&type=script&lang=js&"
export * from "./BottomPopup.vue?vue&type=script&lang=js&"
import style0 from "./BottomPopup.vue?vue&type=style&index=0&id=12c2e9c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2e9c5",
  null
  
)

export default component.exports